import { render, staticRenderFns } from "./MonitorEsg2.vue?vue&type=template&id=352ec4f0&scoped=true"
import script from "./MonitorEsg2.vue?vue&type=script&lang=js"
export * from "./MonitorEsg2.vue?vue&type=script&lang=js"
import style0 from "./MonitorEsg2.vue?vue&type=style&index=0&id=352ec4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ec4f0",
  null
  
)

export default component.exports